import * as React from "react";

import { Button } from "@replohq/lattice/components/button/Button";

export const StepActions: React.FC<{
  submitLabel: string;
  isSubmitting: boolean;
  submitDisabled?: boolean;
  onSubmit?: () => void;
  onDismiss?: () => void;
}> = ({ submitLabel, isSubmitting, submitDisabled, onSubmit, onDismiss }) => (
  <div className="flex flex-col gap-3">
    <Button
      variant="primary"
      size="base"
      type={onSubmit ? "button" : "submit"}
      loading={isSubmitting}
      disabled={isSubmitting || submitDisabled}
      onClick={onSubmit}
      className="w-full"
    >
      {submitLabel}
    </Button>
    {onDismiss && (
      <Button
        type="button"
        variant="tertiary"
        size="base"
        onClick={onDismiss}
        disabled={isSubmitting}
        className="w-full"
      >
        No thanks
      </Button>
    )}
  </div>
);
